import * as React from 'react';
import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { first, values } from 'es-toolkit/compat';
import { useSelector } from 'react-redux';
import LoadingComponent from '@tock/shared/components/LoadingComponent';
import ReceiptTitle from 'components/business/receipts/ReceiptTitle';
import SecondaryReceipt from 'components/business/receipts/SecondaryReceipt';

const SecondaryReceiptRoute: React.FunctionComponent<{}> = () => {
  const { business, purchaseOrder, patron, pastPurchase } = useSelector((state: StoreType) => ({
    purchaseOrder: state.purchase.calculatedPrice,
    visitEditToken: state.selection.visitEditToken,
    business: state.app.config?.business,
    pastPurchase: state.pastPurchase.pastPurchase,
    patron: state.app.patron,
  }));

  if (!purchaseOrder || !patron) {
    // todo skeleton loading state
    return <LoadingComponent isBallPulse={true} />;
  }

  return (
    <div className="MainContent">
      <div className="SectionWrapper">
        <div className="SectionContent">
          <ReceiptTitle
            purchase={first(values(pastPurchase)) as core.PastPurchase}
            ownerPatron={purchaseOrder.patron || undefined}
            businessName={business?.name || undefined}
            isVisitEdit={true}
            confirmationId={purchaseOrder.confirmationId}
          />
          <div className="Receipt-content--flexContainer">
            <SecondaryReceipt patron={patron} purchaseOrder={purchaseOrder} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondaryReceiptRoute;
